// Kerala events are always shown and entered in India time (IST, UTC+5:30, no DST),
// so a visitor or admin in Toronto still sees the time printed on the poster.
export const KERALA_TZ = 'Asia/Kolkata';
const IST_OFFSET_MS = 330 * 60000;

const fmt = (options) => new Intl.DateTimeFormat('en-IN', { timeZone: KERALA_TZ, ...options });
const dayKey = (date) => fmt({ year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);

// "Sat, 25 Oct · 7:30 pm" for single-day events, "11 – 18 Dec 2026" for multi-day ones.
export function formatEventWhen(startsAt, endsAt) {
  if (!startsAt) return '';
  const start = new Date(startsAt);
  const end = endsAt ? new Date(endsAt) : null;
  if (end && dayKey(start) !== dayKey(end)) {
    const sameMonth = fmt({ month: 'short', year: 'numeric' }).format(start) === fmt({ month: 'short', year: 'numeric' }).format(end);
    const from = sameMonth ? fmt({ day: 'numeric' }).format(start) : fmt({ day: 'numeric', month: 'short' }).format(start);
    return `${from} – ${fmt({ day: 'numeric', month: 'short', year: 'numeric' }).format(end)}`;
  }
  const day = fmt({ weekday: 'short', day: 'numeric', month: 'short' }).format(start);
  return isTimeTba(start) ? day : `${day} · ${fmt({ hour: 'numeric', minute: '2-digit' }).format(start)}`;
}

// A start of exactly midnight IST means the organiser hasn't announced a time yet.
const isTimeTba = (date) => (date.getTime() + IST_OFFSET_MS) % 86400000 === 0;

export const monthLabel = (date) => fmt({ month: 'long', year: 'numeric' }).format(new Date(date));

// <input type="datetime-local"> has no timezone, so convert to/from IST wall-clock time explicitly.
export const toIstInput = (value) => value ? new Date(new Date(value).getTime() + IST_OFFSET_MS).toISOString().slice(0, 16) : '';
export const fromIstInput = (value) => value ? new Date(new Date(`${value}:00Z`).getTime() - IST_OFFSET_MS).toISOString() : null;
